import { HttpHeaders } from '@angular/common/http';
import { ApiResponse } from '../../../core/shared/classes/api';
import { ApiService } from '../../../core/services/api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class OptimaxService {

    constructor (private apiService: ApiService) {}

    getEmails(type: string, nextPageToken?: string): Observable<ApiResponse> {
        const params = {optimaxToken: localStorage.getItem('optimaxToken')};
        if (nextPageToken) {
            params['nextPageToken'] = nextPageToken;
        }
        return this.apiService.get('optimax/mailing/type/' + type, {params: params});
    }

    getEmail(id: string): Observable<ApiResponse> {
        return this.apiService.get('optimax/mailing/' + id, {params: {optimaxToken: localStorage.getItem('optimaxToken')}});
    }

    getEmailsByAddress(adresse: string, nextPageToken?: {}): Observable<ApiResponse> {
        const params = {optimaxToken: localStorage.getItem('optimaxToken'), email: adresse};
        if (nextPageToken) {
            params['nextPageTokenFrom'] = nextPageToken['from'];
            params['nextPageTokenTo'] = nextPageToken['to'];
        }
        return this.apiService.get('optimax/mailingOperation/fetchMailByAddress', {params: params});
    }

    createDraft(email: {}): Observable<ApiResponse> {
        return this.apiService.post('optimax/mailing', email);
    }

    updateDraft(id: string, email: {}): Observable<ApiResponse> {
        return this.apiService.put('optimax/mailing/' + id, email);
    }

    deleteEmail(id: string): Observable<ApiResponse> {
        return this.apiService.delete('optimax/mailing/' + id);
    }

    deleteEmails(emails: any[]): Observable<ApiResponse> {
        return this.apiService.post('optimax/mailingOperation/deleteMultiple', emails);
    }

    sendEmail(email: {}): Observable<ApiResponse> {
        return this.apiService.post('optimax/mailingOperation/sendEmail', email);
    }

    getUsersOptimax(): Observable<ApiResponse> {
        return this.apiService.get('optimax/authentication/getUsersOptimax');
    }

    getGlobaleUsersOptimax(): Observable<ApiResponse> {
        return this.apiService.get('optimax/authentication/getGlobalUserOptimax');
    }

    connectOptimax(userId: number): Observable<ApiResponse> {
        return this.apiService.post('optimax/authentication/connectOptimax', {userId: userId});
    }

    getUrlAuthorization(passerelle: string, optimaxToken, type?: string): Observable<ApiResponse> {
        const params = {optimaxToken: optimaxToken};
        if (type) {
            params['type'] = type;
        }
        return this.apiService.get('optimax/authentication/getUrlAuthorization/' + passerelle, {params: params});
    }

    checkUserApi(optimaxToken): Observable<ApiResponse> {
        return this.apiService.get('optimax/authentication/checkUserApi', {params: {optimaxToken: optimaxToken}});
    }

    createUser(libelle: string, isGlobale = false): Observable<ApiResponse> {
        return this.apiService.post('optimax/authentication/createUser', {libelle: libelle, global_user: isGlobale});
    }

    deleteUser(userId: number): Observable<ApiResponse> {
        return this.apiService.post('optimax/authentication/deleteUser', {userId: userId});
    }

    resetOptimaxUser(optimaxUser): Observable<ApiResponse> {
        return this.apiService.post('optimax/authentication/resetOptimaxUser', {optimaxUser: optimaxUser});
    }

    getComposeEmailUrl(view?: string) {
        const params = {optimaxToken: localStorage.getItem('optimaxToken')};
        if (view) {
            params['view'] = view;
        }
        return this.apiService.get('optimax/mailingOperation/getMailboxUrl', {params: params});
    }

    insertContext(data): Observable<ApiResponse> {
        return this.apiService.post('optimax/context', JSON.stringify(data));
    }

    deleteContext(resource, resourceId): Observable<ApiResponse> {
        return this.apiService.delete(`optimax/context/resource/${resource}/${resourceId}`);
    }
}
